import React, { Component } from 'react';
import { Action, bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Box, Button } from '@mui/material';

import { hasProjectHierarchyFeatureFlag } from '@paragon/login-tools';

import { RootState } from '../../../../store';
import { closeSettingsPanel } from '../../../../store/actions/appActions';
import { settingsPanelIsInProjectContext } from '../../../../store/selectors/settingsPanelSelectors';
import { ConfirmCancel } from '../../../dialogs/ConfirmCancel';
import { SaveSettingsSplitButton } from './SaveSettingsSplitButton';

export enum SaveAction {
  DefaultsForHierarchy,
  DefaultsForSingleLevel,
  ActualForHierarchy,
  ActualForSingleComponent,
}

export type SaveSettingsHandler = (type: SaveAction) => void;

interface State {
  dialogOpen: boolean;
}

type OwnProps = {
  userVisibleModelType: string;

  enableSaving: boolean;
  disableSavingActualSettings?: boolean;

  onSave: SaveSettingsHandler;
};

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export type SettingsSaveButtonProps = Props & OwnProps;

class SettingsSaveButton extends Component<SettingsSaveButtonProps> {
  state: State = {
    dialogOpen: false,
  };

  get validSaveActions() {
    const result = [];

    if (this.props.inProjectContext) {
      result.push(SaveAction.DefaultsForHierarchy);

      if (this.props.projectHierarchyEnabled) {
        result.push(SaveAction.DefaultsForSingleLevel);
      }
    }

    if (this.props.disableSavingActualSettings) return result;

    if (this.props.inProjectContext) {
      result.push(SaveAction.ActualForHierarchy);
    } else {
      result.push(SaveAction.ActualForSingleComponent);
    }

    return result;
  }

  onCancelClick = () => {
    if (this.props.enableSaving) {
      this.setState({ dialogOpen: true });
    } else {
      this.props.closeSettingsPanel();
    }
  };

  onClose = (confirmed: boolean) => {
    this.setState({ dialogOpen: false });
    if (!confirmed) {
      return;
    }
    this.props.closeSettingsPanel();
  };

  render() {
    const dialog = this.state.dialogOpen && <ConfirmCancel onClose={this.onClose} />;

    return (
      <Box sx={{ p: 1, display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
        <div>
          <Button sx={{ py: 1, m: 1, mr: 0 }} variant="outlined" onClick={this.onCancelClick}>
            Cancel
          </Button>
        </div>
        <div>
          <SaveSettingsSplitButton
            {...this.props}
            userVisibleModelType={this.props.userVisibleModelType}
            validSaveActions={this.validSaveActions}
          />
        </div>

        {dialog}
      </Box>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  inProjectContext: settingsPanelIsInProjectContext(state),
  projectHierarchyEnabled: hasProjectHierarchyFeatureFlag(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) =>
  bindActionCreators(
    {
      closeSettingsPanel,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(SettingsSaveButton);
